import React from "react";
import "./css/d3.css";

export default function MenuTemplate3({ menu, categories }) {
  if (!menu || !categories) return <p>Loading…</p>;

  const colors = menu.colors || {
    primary: "#000",
    background: "#fafafa",
    text: "#1f1f1f",
    card: "#ffffff",
  };

  return (
    <div
      className="t3-container"
      style={{ backgroundColor: colors.background, color: colors.text }}
    >
      {/* HEADER */}
      <div className="t3-header">
        {menu.imageUrl && (
          <img src={menu.imageUrl} alt="header" className="t3-headerImage" />
        )}

        <div className="t3-headerText">
          <h1>{menu.name}</h1>
          {menu.tagline && (
            <p className="t3-tagline">{menu.tagline}</p>
          )}
        </div>
      </div>

      <div className="t3-content">
        {categories.map((cat) => (
          <section key={cat.id} className="t3-category">
            <h2
              className="t3-category-title"
              style={{ color: colors.primary }}
            >
              {cat.name}
            </h2>

            <div className="t3-divider" />

            {cat.items.length === 0 && <p className="t3-empty">No items yet</p>}

            <div className="t3-items">
              {cat.items.map((item) => (
                <div key={item.id} className="t3-item">
                  <div className="t3-item-info">
                    <h3>{item.name}</h3>
                    {item.description && (
                      <p className="t3-item-desc">{item.description}</p>
                    )}
                  </div>

                  <div className="t3-item-price">
                    ${parseFloat(item.price).toFixed(2)}
                  </div>
                </div>
              ))}
            </div>

          </section>
        ))}
      </div>
    </div>
  );
}
